import React__default from 'react';
import PropTypes from 'prop-types';

var propTypes = {
  tags: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    removeButton: PropTypes.shape({
      onClick: PropTypes.func.isRequired,
      ariaLabel: PropTypes.string,
      labelText: PropTypes.string
    }).isRequired
  })).isRequired,
  removeAllLink: PropTypes.element
};
function TagGroup(_ref) {
  var removeAllLink = _ref.removeAllLink,
    tags = _ref.tags;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "tag-group",
    "data-testid": "tag-group"
  }, tags.map(function (_ref2) {
    var label = _ref2.label,
      removeButton = _ref2.removeButton;
    var ariaLabel = removeButton.ariaLabel,
      labelText = removeButton.labelText,
      onClick = removeButton.onClick;
    return /*#__PURE__*/React__default.createElement("div", {
      className: "tag-group-tag",
      key: label
    }, label, /*#__PURE__*/React__default.createElement("button", {
      "aria-label": ariaLabel || labelText,
      className: "tag-group-clear-tag",
      onClick: onClick,
      type: "button"
    }, /*#__PURE__*/React__default.createElement("span", {
      "aria-hidden": "true",
      className: "tag-clear-icon",
      "data-icon": "close",
      "data-testid": "tag-clear-icon"
    })));
  }), removeAllLink);
}
TagGroup.propTypes = propTypes;

export { TagGroup as default };
//# sourceMappingURL=TagGroup.js.map
